import { combineReducers } from "@reduxjs/toolkit";
import socket from "./models/socket/socket";
import texts from "./models/texts";

export const rootReducer = combineReducers({
  socket,
  texts,
});
